import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Box, IconButton } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import EditIcon from "@material-ui/icons/Edit";
import {
  setComplete,
  toggleBeingEdited,
} from "../../../../store/tasks/actions";
import EditTask from "../edit-task";
import useStyles from "./styles";

const TaskList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tasks = useSelector((state) => state.tasks.tasks);

  return tasks.map((task) =>
    task.beingEdited ? (
      <EditTask
        key={task.key}
        oldTitle={task.title}
        oldDescription={task.description}
        beingEdited={true}
        taskKey={task.key}
      />
    ) : (
      <div key={task.key} className={classes.taskBox}>
        {task.complete ? (
          <Box
            className={classes.checkbox}
            onClick={() => dispatch(setComplete(task))}
          >
            <CheckIcon style={{ color: "#2BBE2B" }} />
          </Box>
        ) : (
          <Box
            className={classes.checkbox}
            onClick={() => dispatch(setComplete(task))}
          ></Box>
        )}
        <div className={classes.taskDetails}>
          <Typography className={classes.taskTitle}>{task.title}</Typography>
          <Typography className={classes.taskDescription}>
            {task.description}
          </Typography>
        </div>
        <IconButton
          onClick={() => {
            dispatch(toggleBeingEdited(task));
          }}
        >
          <EditIcon className={classes.edit} />
        </IconButton>
      </div>
    )
  );
};

export default TaskList;
